// src/pages/ContactUs.jsx
import React, { useEffect } from 'react';
import Navbar from '../components/Navbar/navbar';
import Footer from '../components/Footer/Footer';
import './ContactUs.css';
import { Container, Row, Col } from 'react-bootstrap';

const ContactUs = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [formData, setFormData] = React.useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const [status, setStatus] = React.useState({
        submitting: false,
        type: null,
        message: null
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ submitting: true, type: null, message: null });

        try {
            const response = await fetch('/mail.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            // Check if content type is JSON
            const contentType = response.headers.get("content-type");
            if (!contentType || !contentType.includes("application/json")) {
                const text = await response.text(); // Get the HTML/text response
                console.error("Non-JSON Response:", text);
                throw new Error(`Server Error ${response.status}: ${response.statusText}. (See console for details)`);
            }

            const result = await response.json();

            if (response.ok) {
                setStatus({ type: 'success', message: result.message });
                setFormData({ name: '', email: '', phone: '', message: '' }); // Clear form
                document.getElementById('termsCheck').checked = false;
            } else {
                setStatus({ type: 'error', message: result.message || 'Something went wrong.' });
            }
        } catch (error) {
            console.error("Form Submission Error:", error);
            setStatus({ type: 'error', message: `Submission Failed: ${error.message}` });
        } finally {
            setStatus(prev => ({ ...prev, submitting: false }));
        }
    };

    return (
        <div className="contact-us-page ">
            <Navbar />

            <section className="about-hero-section">
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className="about-hero-content">
                                {/* Main Title: About (Regular) Us (Bold) */}
                                <h1 className="about-hero-title">
                                    <span>Contact Us</span>
                                </h1>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <div className="container py-5 my-5">
                <div className="row">

                    {/* LEFT SIDE: Info */}
                    <div className="col-lg-5 mb-5 mb-lg-0">
                        <div className="contact-info-box">
                            <h2 className="fw-bold mb-3">Always Here to Help you</h2>
                            <p className="text-muted mb-5">
                                Reach out to us for automotive component enquiries, RFQs, or technical discussions. We are committed to providing precision solutions.
                            </p>

                            {/* Location */}
                            <div className="d-flex mb-4">
                                <div className="info-icon-circle me-3">
                                    <i className="bi bi-geo-alt-fill"></i>
                                </div>
                                <div>
                                    <div className="contact-label">Location</div>
                                    <div className="contact-text">
                                        NO : 99, SURVEY NO.561 / 1C-2,<br />
                                        PAPPARAMBAKKAM VILLAGE<br />
                                        THIRUVALLUR (TALUK & DISTRICT )– 602 025,<br />
                                        TAMIL NADU<br />
                                        INDIA
                                    </div>
                                </div>
                            </div>

                            {/* Contact */}
                            <div className="d-flex mb-4">
                                <div className="info-icon-circle me-3">
                                    <i className="bi bi-telephone-fill"></i>
                                </div>
                                <div>
                                    <div className="contact-label">Contact</div>
                                    <div className="contact-text">
                                        +91 98403 14831
                                    </div>
                                </div>
                            </div>

                            {/* Email */}
                            <div className="d-flex mb-4">
                                <div className="info-icon-circle me-3">
                                    <i className="bi bi-envelope-fill"></i>
                                </div>
                                <div>
                                    <div className="contact-label">Email</div>
                                    <div className="contact-text">
                                        shanmugaperumal@dynamic-stamping.com
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                    {/* RIGHT SIDE: Form */}
                    <div className="col-lg-7">
                        <div className="contact-form-wrapper">
                            <h3 className="fw-bold mb-2">Ready To Get Started?</h3>
                            <p className="text-muted small mb-4">
                                Your email address will not be published. Required fields are marked.
                            </p>

                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <input
                                        type="text"
                                        className="form-control form-control-custom"
                                        placeholder="Your Name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <input
                                        type="email"
                                        className="form-control form-control-custom"
                                        placeholder="Email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <input
                                        type="tel"
                                        className="form-control form-control-custom"
                                        placeholder="Enter number"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="mb-3">
                                    <textarea
                                        className="form-control form-control-custom"
                                        rows="4"
                                        placeholder="Write a message..."
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div>

                                <div className="form-check mb-4">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="termsCheck"
                                        required
                                    />
                                    <label className="form-check-label small text-muted" htmlFor="termsCheck">
                                        I accept terms and privacy policy.
                                    </label>
                                </div>

                                {status.message && (
                                    <div className={`alert ${status.type === 'success' ? 'alert-success' : 'alert-danger'} mb-3`}>
                                        {status.message}
                                    </div>
                                )}

                                <button type="submit" className="btn btn-message" disabled={status.submitting}>
                                    {status.submitting ? 'Sending...' : 'Send Message'}
                                </button>
                            </form>
                        </div>
                    </div>

                </div>
            </div>

            {/* Map Section */}
            <div className="map-wrapper mt-4 mb-3">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15546.667794833256!2d79.914!3d13.06!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5289c000000001%3A0x0!2zMTPCsDAzJzM2LjAiTiA3OcKwNTQnNTAuNCJF!5e0!3m2!1sen!2sin!4v1650000000000!5m2!1sen!2sin"
                    className="map-frame"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Dynamic Stamping Location"
                ></iframe>
            </div>

            <Footer />
        </div>
    );
};

export default ContactUs;
